import { Icon, IconProps } from '../Icon'

export const CloseIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      close
    </Icon>
  )
}
